import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { logger } from "../../utils/logger";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

export const fetchMoreSpaces = createAsyncThunk(
  "moreSpaces/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.MORES_SPACES);
      return response.data.list;
    } catch (error) {
      logger.error("MoreSpaces API error", error);
      return rejectWithValue(getApiErrorMessage(error, "Failed to load spaces"));
    }
  }
);
